module.exports = __webpack_public_path__ + "static/img/background.269c2fae.svg";